import { GetInstallmentsParams, reportsService } from '@/services';
import { useQuery } from '@tanstack/react-query';

/** Só os filtros — os cards independem de página/ordenação. */
// Sem status: os cards são o breakdown por status e mostram todos os buckets.
type SummaryFilters = Pick<
  GetInstallmentsParams,
  | 'periodFrom'
  | 'periodTo'
  | 'periodType'
  | 'advisoryPartyCode'
  | 'brokerPartyCode'
  | 'productCode'
  | 'branchCode'
  | 'search'
>;

/**
 * Cards do Extrato (Geradas/Pagas/Inadimplentes/A vencer/Canceladas). A queryKey
 * depende SÓ dos filtros, então paginar/ordenar o grid não recalcula a agregação.
 */
export function useInstallmentsSummary(filters: SummaryFilters) {
  const enabled = Boolean(filters.periodFrom && filters.periodTo);

  return useQuery({
    queryKey: ['installments-summary', filters],
    enabled,
    queryFn: async () => {
      const response = await reportsService.getInstallmentsSummary(filters);
      if (!response.success || !response.data) {
        throw new Error(response.error || 'Não foi possível carregar os totalizadores.');
      }
      return response.data;
    },
    staleTime: 1000 * 60 * 5,
  });
}
